{
    "api": {
        "BAD_AUTHENTICATION": "Login invalide",
        "ERR_BAD_RESPONSE": "Une erreur est survenue. Si l'erreur persiste, veuillez contactez le support.",
        "ERR_BAD_REQUEST": "Une erreur est survenue. Si l'erreur persiste, veuillez contactez le support.",
        "ERR_NETWORK": "Erreur réseau. Veuillez réessayer.",
        "EXPIRED_TOKEN": "Le token est expiré !",
        "INVALID_API_KEY": "Clé d'API invalide",
        "INVALID_CODE": "Code invalide",
        "INVALID_LOGIN": "Login ou mot de passe incorrect",
        "INVALID_TOKEN": "Token invalide",
        "INVALID_REQUEST": "Une erreur inconnue est survenue",
        "TOKEN_NOT_FOUND": "Le lien reçu est invalide",
        "TOO_MANY_REQUESTS": "Trop de tentatives, réessayez dans 60 sec.",
        "UNAVAILABLE_EMAIL": "Cette adresse mail est déjà utilisée",
        "UNEXPECTED_ERROR": "Une erreur est survenue. Si l'erreur persiste, veuillez contactez le support.",
        "envelopes": {
            "creation": {
                "INVALID_PARAMETER": "Le couple adresse IP / port est invalide.",
                "RESOURCE_NOT_FOUND": "L'organisation et/ou le TPE n'ont pas été trouvés.",
                "UNAUTHORIZED_PROVIDER": "Vous ne pouvez pas programmer d'enveloppes pour cette organisation.",
                "SCHEDULED_START_DATE_IN_THE_PAST": "La date de début de programmation est dans le passé.",
                "SCHEDULED_END_DATE_IN_THE_PAST": "La date de fin de programmation est dans le passé.",
                "ALREADY_EXISTING_ENVELOPE": "Il existe déjà une enveloppe programmée pour ce terminal.",
                "REDIS_CONNECTION": "Nous n'avons pas pu programmer cette enveloppe, veuillez contactez le support.",
                "INTERNAL_SERVER_ERROR": "Une erreur inconnue est survenue.",
                "TOO_MANY_ITEMS_FOUND": "Le nom de l'organisation correspond à plusieurs organisations différentes.",
                "UNKNOWN_ERROR": "Une erreur inconnue est survenue."
            }
        }
    }
}